module.exports = __webpack_public_path__ + "static/media/banner-services.727ea152.jpg";